import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserStateService {
  private userNameSubject = new BehaviorSubject<string | null>(null);
  public userName$: Observable<string | null> = this.userNameSubject.asObservable();

  setUserName(userName: string): void {
    this.userNameSubject.next(userName);
  }

  get userName(): string | null {
    return this.userNameSubject.value;
  }
}